import './App.css';

import SearchBar from './Components/SearchBar';

function App() {
  return (
    <div className='container'>
      <h1 className='title'>React Movie Search</h1>
      <SearchBar />
    </div>
  );
}

export default App;
